import { useEffect } from "react";
import { useAuthStoreV1 } from "@/stores/authStore_v1";
import { useDevAgentStore } from "@/stores/devAgentStore";
import { useChatPendingInputStore } from "@/stores/chatPendingInputStore";
import { getMetadataItemByName } from "../devAgentService";

const readPendingIntentState = () => useChatPendingInputStore.getState();

export function useConsumeImproveWithAIIntent(params: {
  handleOpenFileInEditor: (file: { id: string; name: string; metadataType?: string }) => void;
}) {
  const { handleOpenFileInEditor } = params;

  useEffect(() => {
    const { improveWithAIIntent, setImproveWithAIIntent } = readPendingIntentState();
    if (!improveWithAIIntent) return;
    setImproveWithAIIntent(null);

    if (improveWithAIIntent.pendingFile) {
      const file = improveWithAIIntent.pendingFile;
      const fileName = file.name.replace(/\.(cls|trigger)$/i, "").replace(/^.*\//, "");
      const metadataType = improveWithAIIntent.metadataType || "ApexClass";
      const rawId = file.id != null ? String(file.id) : "";
      const hasUuid = !!rawId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(rawId);

      void (async () => {
        try {
          let resolvedId = rawId || fileName;
          let content = "";
          if (hasUuid) {
            const { getMetadataItemById } = await import("../devAgentService");
            try {
              const item = await getMetadataItemById(resolvedId);
              content = item?.content || "";
            } catch {
              /* fallback to name lookup */
            }
          }
          if (!content) {
            const orgId = useAuthStoreV1.getState().selectedOrg?.id || "";
            const item = await getMetadataItemByName(fileName, orgId);
            resolvedId = item.id || resolvedId;
            content = item.content || "";
          }
          useDevAgentStore.getState().setPendingFile({
            id: resolvedId,
            name: fileName,
            metadataType,
            content,
          });
          useDevAgentStore.getState().setEditorOpen(true);
        } catch (error) {
          console.warn(
            "[improve-with-ai] failed to resolve file via backend, opening empty tab:",
            error,
          );
          handleOpenFileInEditor({ id: rawId || fileName, name: fileName, metadataType });
        }
      })();
    }

    if (improveWithAIIntent.initialMessage) {
      useDevAgentStore.getState().addFeedItem({
        type: "intent_confirm",
        data: { content: improveWithAIIntent.initialMessage },
      });
    }
  }, [handleOpenFileInEditor]);
}
